<button 
  [class]="'btn-primary dmd-check-btn ' + (isCallFromCustomerDashboard ? 'customer-dashboard-btn' : '')" 
  (click)="performDmdCheck(); $event.stopPropagation();"
  matTooltip="DMD Check ensures that applicants meet the necessary criteria and helps prevent fraud or duplicate enrollments"
  matTooltipPosition="above"
  [matTooltipClass]="'dmd-check-tooltip'"
  style="position: relative;">
  <i class="fas fa-shield-alt"></i> DMD Check
</button> 